module.exports = __webpack_public_path__ + "media/images/menu-history-icon-1afd3a7fcf2c1b7aedb4e79e1fe979be.svg";